const lockBodyScroll = () => {
  const body = document.body;
  const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
  body.style.position = 'fixed';
  body.style.top = `-${scrollY}`;
  body.style.paddingRight = 'calc(100% - 100vw)';
};

const unlockBodyScroll = () => {
  const body = document.body;
  const scrollY = body.style.top;
  body.style.position = '';
  body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
};

export const showModal = (target, callBefore, callBack, settings) => {
  // target - dom элемент или css селектор модального окна, в ином случае
  // селектор возьмется из this (data-modal или href)
  let targetElem;
  if (typeof target === 'string') {
    targetElem = document.querySelector(target);
  }
  else if ((target instanceof Element) && target.getAttribute('data-modal')) {
    targetElem = document.querySelector(target.getAttribute('data-modal'));
  }
  else if ((target instanceof Element) && target.getAttribute('href')) {
    targetElem = document.querySelector(target.getAttribute('href'));
  }
  else if (target instanceof Element) {
    targetElem = target;
  }
  else {
    return false;
  }

  if (typeof callBefore === 'function') {
    callBefore();
  }

  targetElem.classList.add('m-modal_shown');
  lockBodyScroll();

  targetElem.addEventListener('click', (e) => {
    if (e.target === targetElem) {
      return closeModals();
    }
  });
  window.addEventListener('keyup', (e) => {
    if (e.key === 'Escape') {
      return closeModals();
    }

    if (typeof callBack === 'function') {
      callBack();
    }
  });
  const closeBtns = document.querySelectorAll('.m-modal__close');
  [...closeBtns].map((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      return closeModals();
    })
  })

  if (typeof callBack === 'function') {
    callBack();
  }
};

export const closeModals = () => {
  const activeModal = document.querySelector('.m-modal_shown');
  if (activeModal) {
    activeModal.classList.remove('m-modal_shown');
    const video = activeModal.querySelector('#video169');
    if (video) {
      video.innerHTML = '';
    }
    unlockBodyScroll();
    return true;
  }
  return false;
};

export const watchScrollY = () => {
  window.addEventListener('scroll', () => {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
  })
};